/* Prestige Rug House — Main JS (homepage + global) */
(function () {

  // ── GSAP is loaded conditionally on index pages only ───────────────────────
  // layout/theme.liquid loads GSAP + ScrollTrigger on {% if request.page_type == 'index' %} only.
  // This file is loaded on all pages, so guard all GSAP calls.

  var isHomepage = document.body.classList.contains('template-index');

  // ── MOBILE NAV ────────────────────────────────────────────────────────────
  var hamburger = document.getElementById('navHamburger');
  var mobileMenu = document.getElementById('mobileNavMenu');
  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', function () {
      var open = mobileMenu.classList.toggle('open');
      hamburger.classList.toggle('open', open);
      hamburger.setAttribute('aria-expanded', open ? 'true' : 'false');
      mobileMenu.setAttribute('aria-hidden', open ? 'false' : 'true');
      document.body.style.overflow = open ? 'hidden' : '';
    });
    // Close on any link click
    mobileMenu.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        mobileMenu.classList.remove('open');
        hamburger.classList.remove('open');
        hamburger.setAttribute('aria-expanded', 'false');
        mobileMenu.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      });
    });
  }

  // ── EMAIL CAPTURE (Klaviyo) ────────────────────────────────────────────────
  var KL_PUBLIC_KEY = 'WTjFHe';
  var KL_LIST_ID    = 'SErRuG';

  function klaviyoSubscribe(email) {
    return fetch(
      'https://a.klaviyo.com/client/subscriptions/?company_id=' + KL_PUBLIC_KEY,
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              profile: { data: { type: 'profile', attributes: { email: email } } }
            },
            relationships: { list: { data: { type: 'list', id: KL_LIST_ID } } }
          }
        })
      }
    ).then(function (res) { return res.status === 202 || res.ok; });
  }

  function setMsg(el, type, text) {
    el.textContent = text;
    el.className = 'ec-msg ' + type;
  }

  // Inline form (newsletter section)
  var ecInlineForm = document.getElementById('ecInlineForm');
  if (ecInlineForm) {
    ecInlineForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = document.getElementById('ecInlineEmail').value.trim();
      var msg   = document.getElementById('ecInlineMsg');
      var btn   = ecInlineForm.querySelector('.ec-btn');
      btn.textContent = 'Joining...';
      btn.disabled = true;
      klaviyoSubscribe(email).then(function (ok) {
        if (ok) {
          setMsg(msg, 'success', "You're in. Check your inbox for a welcome from us.");
          ecInlineForm.querySelector('input').value = '';
        } else {
          setMsg(msg, 'error', 'Something went wrong. Please try again.');
        }
        btn.textContent = 'Join the House';
        btn.disabled = false;
      }).catch(function () {
        setMsg(msg, 'error', 'Something went wrong. Please try again.');
        btn.textContent = 'Join the House';
        btn.disabled = false;
      });
    });
  }

  // Popup form
  var ecOverlay   = document.getElementById('ecOverlay');
  var ecPopupForm = document.getElementById('ecPopupForm');

  function closePopup() {
    if (!ecOverlay) return;
    ecOverlay.classList.remove('visible');
    setTimeout(function () {
      if (!ecOverlay.classList.contains('visible')) ecOverlay.style.display = 'none';
    }, 400);
  }

  if (ecPopupForm) {
    ecPopupForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = document.getElementById('ecPopupEmail').value.trim();
      var msg   = document.getElementById('ecPopupMsg');
      var btn   = ecPopupForm.querySelector('.ec-btn');
      btn.textContent = 'One moment...';
      btn.disabled = true;
      klaviyoSubscribe(email).then(function (ok) {
        if (ok) {
          setMsg(msg, 'success', 'Done. Your 10% code is on its way.');
          setTimeout(closePopup, 2200);
        } else {
          setMsg(msg, 'error', 'Something went wrong. Please try again.');
        }
        btn.textContent = 'Claim My Discount';
        btn.disabled = false;
      }).catch(function () {
        setMsg(msg, 'error', 'Something went wrong. Please try again.');
        btn.textContent = 'Claim My Discount';
        btn.disabled = false;
      });
    });
  }

  if (ecOverlay) {
    var popupShown = false;
    function showPopup() {
      if (popupShown || sessionStorage.getItem('prh_popup_seen')) return;
      popupShown = true;
      sessionStorage.setItem('prh_popup_seen', '1');
      ecOverlay.style.display = 'flex';
      void ecOverlay.offsetWidth;
      ecOverlay.classList.add('visible');
    }
    var ecClose = document.getElementById('ecClose');
    var ecSkip  = document.getElementById('ecSkip');
    if (ecClose) ecClose.addEventListener('click', closePopup);
    if (ecSkip)  ecSkip.addEventListener('click', closePopup);
    ecOverlay.addEventListener('click', function (e) {
      if (e.target === ecOverlay) closePopup();
    });
    setTimeout(showPopup, 45000);
    document.addEventListener('mouseleave', function (e) {
      if (e.clientY <= 0) showPopup();
    });
  }

  // ── SPOTLIGHT BORDER CARDS ────────────────────────────────────────────────
  document.querySelectorAll('.product-card').forEach(function (card) {
    card.addEventListener('mousemove', function (e) {
      var rect = card.getBoundingClientRect();
      var x = ((e.clientX - rect.left) / rect.width) * 100;
      var y = ((e.clientY - rect.top)  / rect.height) * 100;
      card.style.setProperty('--mx', x + '%');
      card.style.setProperty('--my', y + '%');
    });
  });

  // ── HOMEPAGE GSAP ANIMATIONS ──────────────────────────────────────────────
  if (isHomepage && window.gsap && window.ScrollTrigger) {
    gsap.registerPlugin(ScrollTrigger);

    // Curtain reveal
    var tl = gsap.timeline({ defaults: { ease: 'power3.inOut' } });
    tl.to('#curtainLeft',  { x: '-100%', duration: 1.4 }, 0)
      .to('#curtainRight', { x: '100%',  duration: 1.4 }, 0)
      .to('#heroContent',  { opacity: 1, y: 0, duration: 0.9, ease: 'power2.out' }, 0.6);

    // Sticky showcase panels
    var showcasePanels = document.querySelectorAll('.showcase-panel');
    var showcaseImgs   = document.querySelectorAll('.showcase-img');
    showcasePanels.forEach(function (panel, i) {
      ScrollTrigger.create({
        trigger: panel,
        start: 'top center',
        end: 'bottom center',
        onEnter: function () { activate(i); },
        onEnterBack: function () { activate(i); }
      });
    });
    function activate(idx) {
      showcasePanels.forEach(function (p) { p.classList.remove('active'); });
      showcaseImgs.forEach(function (img) { img.classList.remove('active'); });
      if (showcasePanels[idx]) showcasePanels[idx].classList.add('active');
      var target = document.getElementById('img-' + idx);
      if (target) target.classList.add('active');
    }

    // Scroll reveals
    gsap.utils.toArray('.reveal').forEach(function (el) {
      gsap.to(el, {
        opacity: 1, y: 0, duration: 0.8, ease: 'power2.out',
        scrollTrigger: { trigger: el, start: 'top 88%' }
      });
    });

    // Craft item stagger
    gsap.utils.toArray('.craft-item').forEach(function (item, i) {
      gsap.to(item, {
        opacity: 1, y: 0, duration: 0.7, delay: i * 0.12, ease: 'power2.out',
        scrollTrigger: { trigger: item, start: 'top 88%' }
      });
    });
  } else if (!isHomepage) {
    // Non-homepage: plain CSS reveal via IntersectionObserver
    if (window.IntersectionObserver) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.style.opacity = '1';
            e.target.style.transform = 'translateY(0)';
            e.target.style.transition = 'opacity 0.7s ease, transform 0.7s ease';
            io.unobserve(e.target);
          }
        });
      }, { threshold: 0.12 });
      document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
    } else {
      document.querySelectorAll('.reveal, .craft-item').forEach(function (el) {
        el.style.opacity = '1';
        el.style.transform = 'none';
      });
    }
  }

})();
